export default __webpack_public_path__ + "assets/estatePartner.82fa93f1.webp";